import PropTypes from 'prop-types';
import React from 'react';

import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { StandaloneCheckbox } from 'web-ui-components/lib/data/capture';
import { StandoutTile, ValidationMessageTile } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading, SubHeading } from 'web-ui-components/lib/typography/headings';
import { TickList } from 'web-ui-components/lib/typography/lists';
import { withScrollTop } from '../../containers/withScrollTop';
import { ContentProps } from '../state/propTypes';
import { declarationWebLink } from '../utils/constants';

import { StandardLabel } from 'web-ui-components/lib/typography/labels';
import { WarningDescription } from './WarningDescription';

const SafePayment = (props) => {
	const {
		outcome: {
			checklistItems = [],
			fraud_type: fraudType,
			fraud_mo: fraudMo,
			fraud_mo_emphasis: fraudMoEmphasis,
			protect_yourself: protectYourself = [],
		},
		content: {
			pageHeading,
			pageSubheading,
			protectYourselfText,
			scammedSubheading,
			fraudAwarenessCentreText,
			pageSubheadingStatic,
			fraudAwarenessCentreTextStatic,
			declaration,
			errorText,
		},
		brandId,
		isStaticWarning,
		declarationValue,
		uiError,
		acceptDeclaration,
		isApprovalJourney,
	} = props;

	const itemList = checklistItems.map(({ checklist_item: text }) => <WarningDescription data={text} />);

	const staySafeURL = declarationWebLink[brandId];

	return (
		<div>
			<PageHeading data-test-id="safe-payment">{pageHeading}</PageHeading>
			<p>{isStaticWarning ? pageSubheadingStatic : pageSubheading}</p>
			<TickList items={itemList} />

			{isStaticWarning && (
				<div>
					<SubHeading isFlush>{fraudType}</SubHeading>
					<StandardBody>
						<p>{fraudMo}</p>
						{fraudMoEmphasis && (
							<p>
								<strong>{fraudMoEmphasis}</strong>
							</p>
						)}
					</StandardBody>
					<SubHeading isFlush>{protectYourselfText}</SubHeading>
					{protectYourself.map(({ advice_header: header, advice_text: text }) => (
						<div key={header}>
							<StandardLabel>{header}</StandardLabel>
							<WarningDescription data={text} />
						</div>
					))}
					<StandardBody>
						<WebsiteLink willOpenNewWindow linkText={fraudAwarenessCentreTextStatic} url={staySafeURL} />
					</StandardBody>
				</div>
			)}

			{!isStaticWarning && (
				<StandoutTile.Important>
					<StandardBody>
						{scammedSubheading}
						<WebsiteLink willOpenNewWindow linkText={fraudAwarenessCentreText} url={staySafeURL} />
					</StandardBody>
				</StandoutTile.Important>
			)}

			{!isApprovalJourney && (
				<StandaloneCheckbox
					id="declaration"
					isChecked={declarationValue}
					labelText={declaration}
					onChange={() => acceptDeclaration(!declarationValue)}
				/>
			)}
			{uiError && (
				<div id="errorMsg">
					<ValidationMessageTile messageText={errorText} />
				</div>
			)}
		</div>
	);
};

SafePayment.propTypes = {
	outcome: PropTypes.shape({
		checklistItems: PropTypes.arrayOf(PropTypes.shape({})),
	}),
	content: PropTypes.shape(ContentProps),
	brandId: PropTypes.string.isRequired,
	isStaticWarning: PropTypes.bool,
	declarationValue: PropTypes.bool.isRequired,
	uiError: PropTypes.bool,
	acceptDeclaration: PropTypes.func.isRequired,
	isApprovalJourney: PropTypes.bool,
};

export default withScrollTop(SafePayment);
